import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./DailyBreakdownStyles";

export default class DailyBreakdown extends Component {
  render() {
    let textFormat;

    if (!this.props.filterable) {
      textFormat = "TODAY'S";
    } else if (this.props.period.time_unit === "hour") {
      textFormat = "HOURLY";
    } else if (this.props.period.time_unit === "day") {
      textFormat = "DAILY";
    } else if (this.props.period.time_unit === "week") {
      textFormat = "WEEKLY";
    } else if (this.props.period.time_unit === "month") {
      textFormat = "MONTHLY";
    }
    const isBreakEven =
      this.props.balance.income.toFixed(2) ===
      this.props.balance.cost.toFixed(2);
    const inProfit =
      this.props.balance.income - this.props.balance.cost >= 0.01;

    return (
      <div className={css(styles.breakdownWrapper)}>
        {this.props.balance.income ? (
          <span className={css(styles.breakdownPanel)}>
            <p>GENERATED</p>
            <p className={css(styles.breakdownSold)}>
              {this.props.currency_unit}
              {this.props.balance.income.toFixed(2)}
            </p>
            <p>
              {this.props.energy_balance.generated.toFixed(2)}{" "}
              {this.props.energy_unit}
            </p>
          </span>
        ) : null}
        {this.props.balance.profit_loss ? (
          <span className={css(styles.breakdownPanel)}>
            <p className={css(styles.highlighted)}>{`${textFormat} ${
              isBreakEven ? "BREAK EVEN" : inProfit ? "PROFIT" : "COST"
            }`}</p>
            <p className={css(styles.breakdownCost)}>
              {this.props.currency_unit}
              {Math.abs(this.props.balance.profit_loss).toFixed(2)}
            </p>
            <p>
              {(
                this.props.energy_balance.generated +
                this.props.energy_balance.consumed
              ).toFixed(2)}{" "}
              {this.props.energy_unit}
            </p>
          </span>
        ) : null}
        {this.props.balance.income && this.props.balance.cost ? (
          <span className={css(styles.breakdownPanel)}>
            <p>CONSUMED</p>
            <p className={css(styles.breakdownBought)}>
              {this.props.currency_unit}
              {this.props.balance.cost.toFixed(2)}
            </p>
            <p>
              {this.props.energy_balance.consumed.toFixed(2)}{" "}
              {this.props.energy_unit}
            </p>
          </span>
        ) : null}
        {this.props.energy_unit_desc && this.props.balance.income ? (
          <span className={css(styles.desc)}>
            {this.props.energy_unit_desc}
          </span>
        ) : null}
        {this.props.showPraise &&
          inProfit && (
            <span className={css(styles.praise)}>
              Well done! You were in profit
            </span>
          )}
      </div>
    );
  }
}
